import { AccountType, Term } from "@/api/generated/graphql";

export const orderedTerms: Term[] = [
  // Term.OneMonth,
  // Term.TwoMonths,
  // Term.ThreeMonths,
  Term.SixMonths,
  Term.NineMonths,
  Term.TwelveMonths,
  Term.EighteenMonths,
  Term.TwoYears,
  Term.ThreeYears,
  Term.FourYears,
  Term.FiveYears,
];

export const orderedAccountType = [...new Set([AccountType.Transaction, AccountType.Savings, ...Object.values(AccountType)])];
